export const HOURS_PREFIX = "Hours";

export const HOURS_CLASSES = {
  detailsLabel: `${HOURS_PREFIX}-detailsLabel`,
  detailsText: `${HOURS_PREFIX}-detailsText`,
  detailsTextLink: `${HOURS_PREFIX}-detailsTextLink`,
  hours: `${HOURS_PREFIX}-hours`,
  hoursText: `${HOURS_PREFIX}-hoursText`,
  hoursCurrent: `${HOURS_PREFIX}-hoursCurrent`,
  hoursSpecial: `${HOURS_PREFIX}-hoursSpecial`,
  hoursSpecialText: `${HOURS_PREFIX}-hoursSpecialText`,
};
